import type { ReactNode } from "react";
import { OpsPaperworkPanel } from "@/components/ops/OpsPaperworkPanel";
import { DealTypesPanel } from "@/components/ops/DealTypesPanel";
import { OpsRtoTermsPanel } from "@/components/ops/OpsRtoTermsPanel";
import { OpsDailyChecklistPanel } from "@/components/ops/OpsDailyChecklistPanel";
import { OpsPhysicalInventoryPanel } from "@/components/ops/OpsPhysicalInventoryPanel";
import { OpsLookupPanel } from "@/components/ops/OpsLookupPanel";
import { OpsObligationsPanel } from "@/components/ops/OpsObligationsPanel";
import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";

/** Ops-bucket mode panels extracted from LeadWorkspaceShellModes for file-size hygiene. */
export function renderLeadWorkspaceOpsMode(mode: PrimaryMode): ReactNode | null {
  switch (mode) {
    case "operations":
      return <OpsPaperworkPanel />;
    case "dealTypes":
      return <DealTypesPanel />;
    case "opsLookup":
      return <OpsLookupPanel />;
    case "opsObligations":
      return <OpsObligationsPanel />;
    case "rtoTerms":
      return <OpsRtoTermsPanel />;
    case "dailyChecklist":
      return <OpsDailyChecklistPanel />;
    case "physicalInventory":
      return <OpsPhysicalInventoryPanel />;
    default:
      return null;
  }
}
